module.exports = __webpack_public_path__ + "static/31-85dfdd30dfb0315c387d6854bf74ebde.jpg";